export enum RestVersions {
  V1 = 'v1',
  V2 = 'v2'
}
